<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text" *ngIf="!isLoading">
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl"
        (onClick)="back()"></app-circle-button>
      <div class="text-lg text-theme-text font-semibold">{{getString("Språk", "upper")}}</div>
    </div>

    <div class="mt-4">
      <div class="payment-button" *ngFor="let lang of languages" (click)="selectLang(lang)">
        <div class="payment-button-text">{{lang.flag}} {{lang.name}} ({{lang.code}})</div>
      </div>
    </div>
    <div *ngIf="isLoading"
      class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
      <app-loading-spinner size="xl"></app-loading-spinner>
    </div>

  </div>
</div>